<template>
    <v-list dense class="menu-items">
        <template v-for="item in items">
            <v-list-group v-if="item.children" :key="item.text">
                <template v-slot:activator>
                    <v-list-item-title>
                        {{item.text}}
                    </v-list-item-title>
                </template>

                <v-list-item v-for="(child, i) in item.children" class="blue-grey lighten-5" :key="i">
                    <!--Grand child element-->
                    <v-list-group sub-group no-action v-if="child.children" class="ml-n5">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <router-link v-for="(grandChild, j) in child.children" :key="j" :to="route(grandChild.route, grandChild.filter)" class="mt-n7">
                            <v-list-item class="blue-grey lighten-5" link>
                                <v-list-item-action v-if="grandChild.icon">
                                    <v-icon>{{ grandChild.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ grandChild.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                    </v-list-group>
                    <!-- End grand child element-->

                    <router-link :to="route(child.route, child.filter)" v-else class="ml-n5">
                        <v-list-item>
                            <v-list-item-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-list-item>
            </v-list-group>

            <router-link v-else :key="item.text" :to="route(item.route)">
                <v-list-item>
                    <v-list-item-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
        </template>
    </v-list>
</template>

<script>
    export default {
        data() {
            return {
                menuItems: [
                    { text: 'Home', route: '/' },
                    { text: 'Profile', route: '/member-profile', claim: 'MemberProfile', visible: () => this.hasClaim('MemberProfile') && !this.hasClaim('AuditorProfile') },
                    { text: 'Profile', route: '/auditor-profile', claim: 'AuditorProfile', visible: () => this.hasClaim('AuditorProfile') && !this.hasClaim('MemberProfile') },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Reports',
                        model: false,
                        children: [
                            { icon: 'mdi-bug-outline', text: 'Disease/Pest Report', route: '/affliction-report', claim: "AfflictionReport" },
                            { icon: 'mdi-flower', text: 'Pollination Density Report', route: '/pollination-density-report', claim: "PollinationDensityReport" },
                            { icon: 'mdi-cup', text: 'Honey Yield Report', route: '/honey-yield-report', claim: "HoneyYieldReport" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Beekeeping',
                        model: false,
                        children: [
                            { icon: 'mdi-truck', text: 'Loads', route: '/loads', claim: "Loads" },
                            { icon: 'mdi-tractor', text: 'Harvestings', route: '/harvestings', claim: "Harvestings" },
                            { icon: 'mdi-sitemap', text: 'Sites', route: '/sites', claim: "Sites" },
                            { icon: 'mdi-sunglasses', text: 'Inspections', route: '/inspections', claim: "Inspections" },
                            { icon: 'mdi-barn', text: 'Landowners', route: '/landowners', claim: "Landowners" },
                            { icon: 'mdi-chemical-weapon', text: 'Biosecurity Incidents', route: '/biosecurity-incidents', claim: "BiosecurityIncidents" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Sample Testing',
                        model: false,
                        children: [
                            { icon: 'mdi-needle', text: 'Samples', route: '/samples', claim: "Samples" },
                            { icon: 'mdi-clipboard-text', text: 'Test Results', route: '/test-results', claim: "TestResults" },
                            { icon: 'mdi-package-variant', text: 'Sample Sets', route: '/sample-set-management', claim: "SampleSetTests" },
                            { icon: 'mdi-test-tube', text: 'Lab Tests', route: '/lab-test-management', claim: "LabTests" },
                            { icon: 'mdi-test-tube-empty', text: 'Tests', route: '/test-management', claim: "Tests" }
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Purchases',
                        model: false,
                        children: [
                            { icon: 'mdi-food', text: 'Feed Purchases', route: '/feed-purchases', claim: "FeedPurchases" },
                            { icon: 'mdi-test-tube', text: 'Chemical Purchases', route: '/chemical-purchases', claim: "ChemicalPurchases" },
                            { icon: 'mdi-chess-queen', text: 'Queen Purchases', route: '/queen-purchases', claim: "QueenPurchases" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Honey',
                        model: false,
                        children: [
                            { icon: 'mdi-package-variant', text: 'Containers', route: '/containers', claim: "Containers" },
                            { icon: 'mdi-package-variant-closed', text: 'Packer Containers', route: '/packer-containers', claim: "PackerContainers" },
                            { icon: 'mdi-cash', text: 'Container Sales', route: '/sales', claim: "Sales" },
                            { icon: 'mdi-tank', text: 'Blend Suppliers', route: '/blend-suppliers', claim: "BlendSuppliers" },
                            { icon: 'mdi-cart-arrow-down', text: 'Blend Receivals', route: '/blend-receivals', claim: "BlendReceivals" },
                            { icon: 'mdi-blender', text: 'Blends', route: '/blends', claim: "Blends" },
                            { icon: 'mdi-test-tube', text: 'Container Tests', route: '/container-tests', claim: "ContainerTests" },
                            { icon: 'mdi-silverware-spoon', text: 'Samplings', route: '/samplings', claim: "Samplings" },
                            { icon: 'mdi-alpha-b-box-outline', text: 'Products', route: '/products', claim: "Products" },
                            { icon: 'mdi-truck-delivery', text: 'Product Dispatches', route: '/product-dispatches', claim: "ProductDispatches" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Business',
                        model: false,
                        children: [
                            { icon: 'mdi-clipboard-plus', text: 'Staff Members', route: '/staff-members', claim: "StaffMembers" },
                            { icon: 'mdi-certificate', text: 'Qualifications', route: '/qualifications', claim: "Qualifications" },
                            { icon: 'mdi-hospital-building', text: 'Facilities', route: '/facilities', claim: "Facilities" },
                            { icon: 'mdi-spray', text: 'Cleanings', route: '/cleanings', claim: "Cleanings" },
                            { icon: 'mdi-thermometer', text: 'Temperature Checks', route: '/temperature-checks', claim: "TemperatureChecks" },
                            { icon: 'mdi-bug', text: 'Pest Controls', route: '/pest-controls', claim: "PestControls" },
                            { icon: 'mdi-hammer', text: 'Equipment Items', route: '/equipment-items', claim: "EquipmentItems" },
                            { icon: 'mdi-scale', text: 'Calibrations', route: '/calibrations', claim: "Calibrations" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Public Data',
                        model: false,
                        children: [
                            { icon: 'mdi-account-question', text: 'Request an Item', route: '/requests', claim: "Requests" },
                            { icon: 'mdi-test-tube', text: 'Chemicals', route: '/chemicals', claim: "Chemicals" },
                            { icon: 'mdi-bug-outline', text: 'Pests/Diseases', route: '/afflictions', claim: "Afflictions" },
                            { icon: 'mdi-food', text: 'Feeds', route: '/feeds', claim: "Feeds" },
                            { icon: 'mdi-flower-outline', text: 'Floral Varieties', route: '/floral-varieties', claim: "FloralVarieties" },
                            { icon: 'mdi-test-tube-empty', text: 'Container Test Types', route: '/container-test-types', claim: "ContainerTestTypes" },
                            { icon: 'mdi-format-list-bulleted-type', text: 'Honey Types', route: '/honey-types', claim: "HoneyTypes" },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Audits',
                        model: false,
                        children: [
                            { icon: 'mdi-clipboard-plus', text: 'New Audit', route: '/audit-members', claim: "Audits", requiresWrite: true },
                            { icon: 'mdi-clipboard', text: 'Audits', route: '/audits', claim: "Audits" },
                            { icon: 'mdi-clipboard-alert', text: 'Corrective Action Requests', route: '/corrective-action-requests', claim: "CorrectiveActionRequests" },
                            { icon: 'mdi-clipboard', text: 'Internal Member Audits', route: '/internal-member-audits', claim: "InternalMemberAudits" },
                            { icon: 'mdi-clipboard-alert', text: 'Internal Corrective Action Requests', route: '/internal-corrective-action-requests', claim: "InternalCorrectiveActionRequests" },
                            { icon: 'mdi-account-child', text: 'Auditor Members', route: '/auditor-members', claim: "AuditorMembers", requiresWrite: true },
                        ],
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Users',
                        model: false,
                        children: [
                            { icon: 'mdi-account', text: 'Members', route: '/members', claim: "Members" },
                            { icon: 'mdi-account-search', text: 'Auditors', route: '/auditors', claim: "Auditors" },
                            { icon: 'mdi-account-tie', text: 'Administrators', route: '/administrators', claim: "Users" },
                            { icon: 'mdi-account', text: 'Biosecurity Organisations', route: '/biosecurity-organisations', claim: "BiosecurityOrganisations" },
                            { icon: 'mdi-map', text: 'State Biosecurity Emails', route: '/state-biosecurity-emails', claim: "StateBiosecurityEmails" },
                            { icon: 'mdi-account', text: 'Third Party App Developers', route: '/third-party-app-developers', claim: "ThirdPartyAppDevelopers" },
                            { icon: 'mdi-alpha-a-circle', text: 'OAuth Clients', route: '/oauth-clients', claim: "OauthClients" },
                            { icon: 'mdi-alpha-g-circle', text: 'OAuth Grants', route: '/oauth-grants', claim: "OauthGrants" },
                        ],
                    },
                    { icon: 'mdi-file-excel', text: 'Excel Imports', route: '/excel-imports', claim: 'ExcelImports', requiresWrite: false },
                    { icon: 'mdi-routes', text: 'All Routes', route: '/master-router', claim: 'MasterRouter', requiresWrite: false },
                ]
            }
        },

        methods: {
            route(path, filter) {
                if (!path) { return; }
                var options = { path };
                if (filter) { options.query = { filter }; }
                return options;
            },
            menuIcon(item) {
                item.model = item.model ? false : true;
            },
            filterOutInvisibleMenuItems(items) {
                return items.filter(mi => (mi.visible === undefined || mi.visible()) // Filter out items marked as invisible
                    && (mi.claim === undefined || this.hasClaim(mi.claim, mi.requiresWrite))) // Filter out items that require a claim we don't have
                    .map(mi => {
                        // If we have children iterate over them and filter out the invisible ones
                        if (mi.children === undefined) {
                            return mi;
                        }
                        else {
                            let clonedObj = Object.assign({}, mi);
                            clonedObj.children = this.filterOutInvisibleMenuItems(clonedObj.children);
                            return clonedObj;
                        }
                    })
                    .filter(mi => {
                        // Menu items with an empty list of children are in that state because they the user doesn't any of the necessary claims. We can safely remove the entire menu
                        return mi.children === undefined || mi.children.length > 0;
                    });
            }
        },

        computed: {
            items() {
                return this.filterOutInvisibleMenuItems(this.menuItems);
            }
        }
    };
</script>

<style type="text/css">
    #bqual .v-list-item__action:first-child {
        margin-right: 16px;
    }

    #bqual .menu-items a {
        text-decoration: none;
        color: inherit;
    }
</style>
